<div class="profileSettings">
  <section class="profileSection" [attr.aria-label]="'common.language' | translate">
    <app-lang-switch [persistAuthenticated]="true" />
  </section>

  <app-notifications-settings
    *appHasPermission="{ permissions: [permissions.allPermissions.NOTIFICATION_READ] }"
    class="profileSection"
    (saved)="close()"
  />
</div>
